export default __webpack_public_path__ + "fc7d413dc65cc80d81ce937b441d2487.svg";